<template>
  <div class="table_pager">
    <button class="prev" @click="prevPage" v-show="page !== 1"></button>
    <button
      :class="{ on: value === item }"
      v-for="item in pageList"
      :key="item"
      @click="changePage(item)"
    >
      {{ item }}
    </button>
    <button
      class="next"
      @click="nextPage"
      v-show="page !== totalPage && totalPage > 0"
    ></button>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    page: {
      type: [Number],
      default: 1
    },
    pageBlock: {
      type: [Number],
      default: 1
    },
    rowPerPage: {
      type: [Number],
      default: 10
    },
    pagePerBlock: {
      type: [Number],
      description: '페이징처리시 노출 페이지 개수',
      default: 10
    },
    totalRow: {
      type: [Number],
      default: 0
    },
    virtualNum: {
      type: [Number],
      default: 0
    },
    totalPage: {
      type: [Number],
      default: 1
    },
    totalBlock: {
      type: [Number],
      description: '페이징처리시 노출 페이지 블록 개수',
      default: 1
    },
    startPage: {
      type: [Number],
      default: 1
    },
    endPage: {
      type: [Number],
      default: 1
    },
    isPrevBlock: {
      type: [Number],
      default: 0
    },
    isNextBlock: {
      type: [Number],
      default: 0
    },
    startIdx: {
      type: [Number],
      default: 0
    },
    value: {
      type: [Number],
      default: 1
    }
  },
  data: function() {
    return {
      defaultPagesToDisplay: 5,
      total: this.totalPage,
      perPage: this.rowPerPage,
      pageCount: 0
    }
  },
  computed: {
    pageList() {
      return this.$_.range(this.startPage, this.endPage + 1)
    },
    totalPages() {
      if (this.pageCount > 0) return this.pageCount
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage)
      }
      return 1
    },
    pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages
      }
      return this.defaultPagesToDisplay
    }
  },
  methods: {
    range(min, max) {
      const arr = []
      for (let i = min; i <= max; i++) {
        arr.push(i)
      }
      return arr
    },
    changePage(item) {
      this.$emit('change', item)
    },
    nextPage() {
      if (this.value < this.totalPage) {
        this.$emit('change', this.value + 1)
      }
    },
    prevPage() {
      if (this.value > 1) {
        this.$emit('change', this.value - 1)
      }
    },
    prevBlock() {
      if (this.isPrevBlock) {
        this.$emit('change', this.pagePerBlock * (this.pageBlock - 1))
      }
    },
    nextBlock() {
      if (this.isNextBlock) {
        this.$emit('change', this.pagePerBlock * this.pageBlock + 1)
      }
    }
  },
  watch: {
    perPage() {
      this.$emit('change', 1)
    },
    total() {
      this.$emit('change', 1)
    }
  }
}
</script>

<style scoped></style>
